import { render, staticRenderFns } from "./VersionLink.vue?vue&type=template&id=e5bfa994"
import script from "./VersionLink.vue?vue&type=script&lang=js"
export * from "./VersionLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports